<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <TeilnehmerHintPills :konfiguration="konfiguration" class="flex-grow-1"></TeilnehmerHintPills>
      <b-button
        v-if="vorgaenge && vorgaenge.length > 0"
        class="icon-button flex-shrink-0 ml-3 mb-4"
        :title="areAllVorgaengeOpen ? 'Alles einklappen' : 'Alles ausklappen'"
        v-b-tooltip.hover
        @click="toggleAllVorgaenge"
      >
        <Maximize2 v-if="!areAllVorgaengeOpen" :size="20" />
        <Minimize2 v-else :size="20" />
      </b-button>
    </div>

    <b-skeleton-table v-if="isLoading" :rows="5" :columns="4"></b-skeleton-table>
    <template v-else>
      <div v-if="!vorgaenge || vorgaenge.length === 0" class="text-muted">Keine Vorgänge vorhanden</div>
      <!-- Gespiegelte Ansicht der Releaseprüfung: rein lesend, ohne Releaseprüfungs-Spalte und ohne Verlauf -->
      <TeilnehmerVorgangCard
        v-for="vorgang in vorgaenge"
        :key="vorgang.id"
        :vorgang="vorgang"
        :konfiguration="konfiguration"
        :reiseterminStartdatum="reiseterminZeitraum.start"
        :reiseterminEnddatum="reiseterminZeitraum.end"
        :isEditAllowed="false"
        :showReleasepruefung="false"
        :verlaufEnabled="false"
        :downloadAllowed="isDownloadAllowed"
        :dokumenteByTeilnehmer="dokumenteByVorgang[vorgang.id] || {}"
        :expanded="!!vorgangOpenState[vorgang.id]"
        @update:expanded="value => $set(vorgangOpenState, vorgang.id, value)"
      ></TeilnehmerVorgangCard>
    </template>
  </div>
</template>

<script>
import TeilnehmerHintPills from './release-teilnehmerdaten/teilnehmer-hint-pills.vue';
import TeilnehmerVorgangCard from './release-teilnehmerdaten/teilnehmer-vorgang-card.vue';
import { groupDokumenteByVorgang } from '@/core/vorgaenge/teilnehmer-passdaten.service';
import {
  hasTeilnehmerdatenVollzugriff,
  getReiseterminZeitraum,
} from '@/core/vorgaenge/helpers/teilnehmer-passdaten.utils';
import { Maximize2, Minimize2 } from 'lucide-vue';

export default {
  components: { TeilnehmerHintPills, TeilnehmerVorgangCard, Maximize2, Minimize2 },
  props: {
    isLoading: { type: Boolean },
    vorgaenge: { type: Array },
    konfiguration: { type: Object },
    reisetermin: { type: Object },
  },
  data() {
    return {
      vorgangOpenState: {},
    };
  },
  computed: {
    dokumenteByVorgang() {
      return groupDokumenteByVorgang(this.vorgaenge);
    },
    areAllVorgaengeOpen() {
      if (!this.vorgaenge || this.vorgaenge.length === 0) return false;
      return this.vorgaenge.every(vorgang => this.vorgangOpenState[vorgang.id] === true);
    },
    // wird für den Geburtstags-Hinweis in der Teilnehmerliste benötigt
    reiseterminZeitraum() {
      return getReiseterminZeitraum(this.reisetermin);
    },
    isDownloadAllowed() {
      return hasTeilnehmerdatenVollzugriff(this.$store);
    },
  },
  methods: {
    toggleAllVorgaenge() {
      const shouldOpen = !this.areAllVorgaengeOpen;
      (this.vorgaenge || []).forEach(vorgang => {
        this.$set(this.vorgangOpenState, vorgang.id, shouldOpen);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.passdaten-col) {
  width: 50rem;
}
:deep(.th-no-padding-top > th) {
  padding-top: 0px;
}
:deep(.th-no-padding-top > th > div) {
  color: var(--text-muted);
}
:deep(.cw-5) {
  width: 5%;
}
:deep(.cw-10) {
  width: 10%;
}
:deep(.cw-30) {
  width: 30%;
}
:deep(.cw-60) {
  width: 60%;
}
</style>
